import { render, staticRenderFns } from "./hospital-list.vue?vue&type=template&id=435fd160&scoped=true&"
import script from "./hospital-list.vue?vue&type=script&lang=js&"
export * from "./hospital-list.vue?vue&type=script&lang=js&"
import style0 from "./hospital-list.vue?vue&type=style&index=0&id=435fd160&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435fd160",
  null
  
)

component.options.__file = "hospital-list.vue"
export default component.exports